import { useState } from 'react';
import type { VistaDeTurnos } from '@medchoice/shared';
import { paciente } from '../../api/paciente';
import { usePedido } from '../../api/usePedido';
import { irA } from '../../router';
import { Boton, Cargando, EstadoVacio, FalloDeCarga, Pestanas } from '../../ui';
import { TarjetaDeTurno } from './TarjetaDeTurno';

export function MisTurnos() {
  const [vista, setVista] = useState<VistaDeTurnos>('proximos');
  const pedido = usePedido(() => paciente.turnos(vista), [vista]);

  return (
    <div className="mis-turnos">
      <header className="mis-turnos__encabezado">
        <h1>Mis turnos</h1>
        <Boton icono="search" onClick={() => irA('/buscar')}>Reservar otro</Boton>
      </header>
      <Pestanas<VistaDeTurnos>
        etiqueta="Mis turnos"
        activa={vista}
        alElegir={setVista}
        pestanas={[{ id: 'proximos', texto: 'Próximos' }, { id: 'historial', texto: 'Historial' }]}
      />
      {pedido.estado === 'cargando' && <Cargando texto="Cargando tus turnos" />}
      {pedido.estado === 'error' && <FalloDeCarga mensaje={pedido.error ?? ''} alReintentar={pedido.recargar} />}
      {pedido.estado === 'listo' && pedido.datos?.length === 0 && (
        vista === 'proximos'
          ? <EstadoVacio icono="calendar" titulo="Sin turnos próximos" cuerpo="Cuando reserves un turno lo vas a ver acá."
              accion={<Boton onClick={() => irA('/buscar')}>Buscar profesionales</Boton>} />
          : <EstadoVacio icono="inbox" titulo="Todavía no tenés historial" />
      )}
      <div className="mis-turnos__lista">
        {pedido.datos?.map((t) => <TarjetaDeTurno key={t.id_turno} turno={t} />)}
      </div>
    </div>
  );
}
